// Basic config by default
import { encrypt, decrypt } from "./test";
//import CryptoJS from 'crypto-js'
var CryptoJS = require("crypto-js");

const baseConfig = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};
// call add new config by parament
const getConfig = (params) => {
  const config = {
    ...baseConfig,
  };

  if (params && params?.headers) {
    config.headers = params.headers;
  }
  return config;
};

export const getWithURLParam = async (httpClient, endpoint, requestData) => {
  //base encoding can go here;
  const config = getConfig({ requestData });

  const response = await httpClient.get(endpoint, config);

  return response;
};
export const getWithURLParamImgPrev = async (
  httpClient,
  endpoint,
  requestData
) => {
  //base encoding can go here;
  const config = getConfig({
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      responseType: "application/json",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  return response;
};

export const getWithURLParamImgDownload = async (
  httpClient,
  endpoint,
  requestData
) => {
  //base encoding can go here;
  const config = getConfig({
    headers: {
      "Content-Type": "image/jpeg",
      Accept: "application/json",
      responseType: "application/octet-stream",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  return response;
};

export const getWithURLFileDownload = async (
  httpClient,
  endpoint,
  requestData
) => {
  const config = { responseType: "arraybuffer" };
  const response = await httpClient.post(endpoint, requestData, config);
  return response;
};

export const post = async (httpClient, endpoint, requestData) => {
  var key;
  var theValueYouWant = endpoint.match("/uaa");
  var isUAA = false;
  const SPMS_INTERNAL_STATE = JSON.parse(
    localStorage.getItem("SPMS_INTERNAL_STATE")
  );
  var USERID = SPMS_INTERNAL_STATE?.auth?.ldapParam?.userId;
  if (theValueYouWant) {
    key = requestData.username.toString();
    isUAA = true
  } else {
    isUAA = false
    key = USERID.toString();
  }
  const config = getConfig();
  // request data parsing logic can go here;
  var ciphertext = encrypt(JSON.stringify(requestData), key, isUAA);
  const response = await httpClient.post(endpoint, ciphertext, config);
  var bytes = decrypt(response.data, key, isUAA);
  var decryptedData = JSON.parse(bytes.toString());
  if (decryptedData) {
    return decryptedData;
  }
  return decryptedData;
};

export const userOnBoardPost = async (httpClient, endpoint, requestData) => {
  const config = getConfig();
  // request data parsing logic can go here;
  const response = await httpClient.post(endpoint, requestData, config);
  if (response) {
    return response;
  }
  return;
};

export const postFile = async (httpClient, endpoint, requestData) => {
  const config = getConfig({
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);
  if (response) {
    return response;
  }
  return;
};
export const postRequest = async (httpClient, endpoint, requestData) => {
  const config = getConfig({
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);
  if (response) {
    return response;
  }
  return;
};
export const postWithCSVResponse = async (
  httpClient,
  endpoint,
  requestData
) => {
  const config = getConfig({
    headers: {
      Accept: "application/csv",
      responseType: "blob",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};

export const put = async (httpClient, endpoint, requestData) => {
  var key;
  var theValueYouWant = endpoint.match("/uaa");
  const SPMS_INTERNAL_STATE = JSON.parse(
    localStorage.getItem("SPMS_INTERNAL_STATE")
  );
  var USERID = SPMS_INTERNAL_STATE?.auth?.ldapParam?.userId;

  if (theValueYouWant) {
    key = "spms$_prod";
  } else {
    key = USERID.toString();
  }

  const config = getConfig();
  var ciphertext = encrypt(JSON.stringify(requestData), key);
  // request data parsing logic can go here;
  const response = await httpClient.put(endpoint, ciphertext, config);
  var bytes = decrypt(response.data, key);
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  if (decryptedData) {
    return decryptedData;
  }
  return;
};

export const deleteAxiosRequest = async (httpClient, endpoint, requestData) => {
  // encoding logic goes here;
  const config = getConfig({ requestData });
  config.data = {};
  const method = httpClient["delete"];
  const response = await method(endpoint, config);
  // additional logic goes here;
  return response;
};

export const patch = async (httpClient, endpoint, requestData) => {
  // encoding logic goes here;
  const config = getConfig();
  const method = httpClient["patch"];
  const response = await method(endpoint, requestData, config);
  // additional logic goes here;
  return response;
};

export const postWithImgPrevTest = async (
  httpClient,
  endpoint,
  requestData
) => {
  const config = getConfig({
    headers: {
      "Content-Type": "image/jpeg",
      Accept: "image/jpeg",
      responseType: "arraybuffer",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};
